import { useTranslation } from "react-i18next";
import { bool } from "prop-types";
import { Grid } from "@material-ui/core";
import useStyle from "./TimelineSettings.style";
import classnames from "classnames";

export const TimelineSettingsHeader = ({ showVisibility }) => {
  const { t } = useTranslation();
  const classes = useStyle();

  return (
    <Grid
      item
      container
      wrap="nowrap"
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid item container className={classnames(classes.headerCell, classes.titleCell)} />
      <Grid item container className={classnames(classes.cell, classes.headerCell, classes.valueCell)}>
        <span>
          {t("views.editor.dialogs.timeline_settings.total_hours")}
        </span>
      </Grid>
      <Grid item container className={classnames(classes.cell, classes.headerCell, classes.valueCell)}>
        <span>
          {t("views.editor.dialogs.timeline_settings.time_allocation")}
        </span>
      </Grid>
      <Grid item container className={classnames(classes.cell, classes.headerCell, classes.colorCell)}>
        <span>
          {t("views.editor.dialogs.timeline_settings.color")}
        </span>
      </Grid>
      {
        showVisibility &&
        <Grid item container className={classnames(classes.cell, classes.headerCell, classes.valueCell)}>
          <span>
              {t("views.editor.dialogs.timeline_settings.display_in_timeline")}
          </span>
        </Grid>
      }
    </Grid>
  );
};

TimelineSettingsHeader.propTypes = { showVisibility: bool };
